import React, { useMemo } from 'react';

export default function Paginator({ pageInfo, onPage }) {
    const totalPage = pageInfo?.totalPage ?? 1;
    const page = pageInfo?.fromPage ?? 1;

    const { canPrev, canNext, pages, showStartEllipsis, showEndEllipsis } = useMemo(() => {
        const current = Math.min(Math.max(1, Number(page) || 1), Math.max(1, Number(totalPage) || 1));
        const tp = Math.max(1, Number(totalPage) || 1);
        const delta = 2; // how many pages around current
        const start = Math.max(1, current - delta);
        const end = Math.min(tp, current + delta);
        const arr = [];
        for (let p = start; p <= end; p++) arr.push(p);
        return {
            canPrev: current > 1,
            canNext: current < tp,
            pages: arr,
            showStartEllipsis: start > 2,
            showEndEllipsis: end < tp - 1,
        };
    }, [page, totalPage]);

    const go = (p) => {
        if (typeof onPage === 'function') onPage(p);
    };

    const btnClass = (p, active) =>
        `${active ? 'text-[#215BD8] bg-[#D7E2F9]' : 'text-[#6C7687] hover:bg-[#F3F5F9]'} px-[15px] py-2 rounded-md font-medium cursor-pointer`;

    return (
        <div
            className="flex items-center justify-center gap-2 font-[Pretendard] text-[15px] mt-[40px] min-[800px]:mt-[40px]"
        >
            <button
                className={`shrink-0 p-2 rounded-md ${canPrev ? 'cursor-pointer' : 'opacity-40 cursor-not-allowed'}`}
                aria-label="prev"
                onClick={() => canPrev && go(page - 1)}
            >
                <img
                    src={`${rmVars.themeUrl}images/pager_prev.png`}
                    alt="prev"
                    className="w-4 h-4"
                />
            </button>

            {totalPage > 0 && (
                <>
                    {/* First page */}
                    {pages[0] !== 1 && (
                        <button className={btnClass(1, page === 1)} onClick={() => go(1)}>1</button>
                    )}

                    {/* Start ellipsis */}
                    {showStartEllipsis && <span className="text-[#6C7687] select-none px-1">...</span>}

                    {/* Middle pages */}
                    {pages.map((p) => (
                        <button key={p} className={btnClass(p, p === page)} onClick={() => go(p)}>
                            {p}
                        </button>
                    ))}

                    {/* End ellipsis */}
                    {showEndEllipsis && <span className="text-[#6C7687] select-none px-1">...</span>}

                    {/* Last page */}
                    {pages[pages.length - 1] !== totalPage && (
                        <button className={btnClass(totalPage, page === totalPage)} onClick={() => go(totalPage)}>
                            {totalPage}
                        </button>
                    )}
                </>
            )}

            <button
                className={`shrink-0 p-2 rounded-md ${canNext ? 'cursor-pointer' : 'opacity-40 cursor-not-allowed'}`}
                aria-label="next"
                onClick={() => canNext && go(page + 1)}
            >
                <img
                    src={`${rmVars.themeUrl}images/pager_next.png`}
                    alt="next"
                    className="w-4 h-4"
                />
            </button>
        </div>
    );
}

